module.exports = __webpack_public_path__ + "static/media/alldogsmatter.03ed5ca1.png";